import {
  SET_STATE,
  INC_STATE,
  SET_ACTIVE_CAMERA,
  CLEAR_ACTIVE_CAMERA,
  LINK_TV_VIDEO,
  LINK_VIDEO,
  UNLINK_VIDEO,
  ADD_OPTIONS,
  RESET,
  SET_LOADING,
  SET_VIDEO_TYPE,
} from './mutation-types';
import { getDefaultState } from './state';

export default {
  [SET_STATE](state, payload) {
    state.state = payload;
  },

  [INC_STATE](state) {
    state.state++;
  },

  [SET_ACTIVE_CAMERA](state, payload) {
    state.activeCamera = payload;
  },

  [CLEAR_ACTIVE_CAMERA](state) {
    state.activeCamera = null;
  },

  [ADD_OPTIONS](state, payload) {
    state.options = {...state.options, ...payload};
  },

  [LINK_TV_VIDEO](state, payload) {
    state.linkedTvVideo = payload;
  },

  [LINK_VIDEO](state, payload) {
    state.linkedVideo = payload;
  },

  [UNLINK_VIDEO](state, payload) {
    state.linkedVideo = state.linkedVideo.filter(item => item.file_id !== payload)
  },

  [RESET](state) {
    Object.assign(state, getDefaultState())
  },

  [SET_LOADING](state, payload) {
    state.loading = payload;
  },

  [SET_VIDEO_TYPE](state, payload) {
    state.type = payload;
  },
};
